import classNames from 'classnames';
import React from 'react';
import ListDataLineChart from './components/list-data-line-chart';
import ListDataTitleDesc from './components/list-data-title-desc';
import { cssClasses, ListItemRightDataSC } from './list-item-right-data.styled';

interface ListItemRightDataProps {
  left?: React.ReactNode;
  right?: React.ReactNode;
  className?: string;
}

const ListItemRightData = ({ left, right, className }: ListItemRightDataProps): JSX.Element => {
  return (
    <ListItemRightDataSC className={classNames(cssClasses.wrapper, className)}>
      {left ? <div className={cssClasses.left}>{left}</div> : null}
      {right ? <div className={cssClasses.right}>{right}</div> : null}
    </ListItemRightDataSC>
  );
};

ListItemRightData.TitleDesc = ListDataTitleDesc;
ListItemRightData.TachometerBar = ListDataLineChart;

export default ListItemRightData;
